export const CONFIGURATION_ENDPOINT={
    get_configurations:`${import.meta.env.VITE_APP_API}/configurations/get-configurations`,
    update_configuration:`${import.meta.env.VITE_APP_API}/configurations/update-configuration`,
}